var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 59 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        isolation: isolate;\n      }\n\n      .st2 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st3 {\n        fill: url(#New_Gradient_Swatch);\n      }\n\n      .st4 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st5 {\n        fill: url(#linear-gradient);\n        mix-blend-mode: multiply;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1.4,38.7c0,2.1,3.3,3,6.5,1.3.3-.2.5-.5.5-1l.4-26.2c-2.5,2-6.3.7-6.9-5.5l-.5,31.4Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1.4,
    y1: 13.6,
    x2: 32.2,
    y2: 13.6,
    gradientTransform: "translate(-8.3 8.6) rotate(90.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf2026"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M42.2,32.4c-.1.2-.3.2-.5.2-15.3,0-40.1-3.6-40.3,6.3L1.9,7.6C2-2.6,27.8,1.4,42.1,1.3c.2,0,.4,0,.5.2l12.1,14.6c.2.2.2.4,0,.6l-12.5,15.5Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch",
    "data-name": "New Gradient Swatch",
    x1: 10.9,
    y1: 10.2,
    x2: 10.9,
    y2: 63.2,
    gradientTransform: "translate(-8.3 8.6) rotate(90.9) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7b1315"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#811517"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a32021"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#be292a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d43130"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e33635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ec3938"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ef3a39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e41e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#b82025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a41c20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#871618"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7d1416"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 141,
    transform: "translate(1.2 7.2) scale(.2)",
    xlinkHref: "SVG-1.png"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.4,38.7c0,2.1,3.3,3,6.5,1.3.3-.2.5-.5.5-1l.4-26.2c-2.5,2-6.3.7-6.9-5.5l-.5,31.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M42.2,32.4c-.1.2-.3.2-.5.2-15.3,0-40.1-3.6-40.3,6.3L1.9,7.6C2-2.6,27.8,1.4,42.1,1.3c.2,0,.4,0,.5.2l12.1,14.6c.2.2.2.4,0,.6l-12.5,15.5Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewSvg);
export default __webpack_public_path__ + "static/media/newSvg.1fdef257513e39d85e9932edbe0c2b51.svg";
export { ForwardRef as ReactComponent };